import { render, staticRenderFns } from "./RelatesInfo.vue?vue&type=template&id=3fe1fcbe&scoped=true&"
import script from "./RelatesInfo.vue?vue&type=script&lang=js&"
export * from "./RelatesInfo.vue?vue&type=script&lang=js&"
import style0 from "./RelatesInfo.vue?vue&type=style&index=0&id=3fe1fcbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe1fcbe",
  null
  
)

export default component.exports